import {
  UPDATE_REVIEW_DATE_REQUEST,
  UPDATE_REVIEW_DATE_SUCCESS,
  UPDATE_REVIEW_DATE_ERROR,
  GET_DETAILS_REQUEST,
  GET_DETAILS_SUCCESS,
  GET_DETAILS_ERROR,
  UPDATE_WORKLOAD_EDITION_REQUEST,
  UPDATE_WORKLOAD_EDITION_SUCCESS,
  UPDATE_WORKLOAD_EDITION_ERROR,
  UPDATE_AUTO_FEED_ACTUALS_REQUEST,
  UPDATE_AUTO_FEED_ACTUALS_SUCCESS,
  UPDATE_AUTO_FEED_ACTUALS_ERROR,
  GET_PORTFOLIO_SUCCESS,
  UPDATE_DETAILS_REQUEST,
  UPDATE_DETAILS_SUCCESS,
  UPDATE_DETAILS_ERROR,
  GET_PORTFOLIO_OPTIONS,
  ADD_PORTFOLIO_OPTION,
  PORTFOLIO_ASSIGNMENTS_CHANGED,
} from "../types";

const initialState = {
  details: {},
  currentScenarioName: "",
  options: [],
  assignmentsVersion: 0,
  loading: false,
  error: "",
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, { type, payload }) {
  switch (type) {
    case GET_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PORTFOLIO_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        details: payload,
      };
    case GET_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        details: payload,
        name: payload.name,
      };
    case GET_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case UPDATE_REVIEW_DATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_REVIEW_DATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        details: {
          ...state.details,
          dateOfReview: payload,
        },
      };
    case UPDATE_REVIEW_DATE_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case UPDATE_WORKLOAD_EDITION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_WORKLOAD_EDITION_SUCCESS:
      return {
        ...state,
        loading: false,
        details: {
          ...state.details,
          workloadEditionEnabled: payload,
        },
        error: "",
      };
    case UPDATE_WORKLOAD_EDITION_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case UPDATE_AUTO_FEED_ACTUALS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_AUTO_FEED_ACTUALS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        details: {
          ...state.details,
          autoFeedActualsEnabled: payload,
        },
      };
    case UPDATE_AUTO_FEED_ACTUALS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case UPDATE_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_DETAILS_SUCCESS:
      const { startDate, finishDate } = state.details;
      return {
        ...state,
        loading: false,
        error: "",
        details: {
          ...payload,
          ...(startDate && finishDate && { startDate, finishDate }),
        },
      };
    case UPDATE_DETAILS_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case GET_PORTFOLIO_OPTIONS:
      return {
        ...state,
        loading: false,
        options: payload,
      };
    case PORTFOLIO_ASSIGNMENTS_CHANGED:
      return {
        ...state,
        assignmentsVersion: state.assignmentsVersion + 1,
        assignedPortfolios: payload || state.assignedPortfolios,
      };
    case ADD_PORTFOLIO_OPTION:
      const newOptions = state.options.slice();
      newOptions.push(payload);
      return { ...state, options: newOptions };
    default:
      return state;
  }
}
